import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { State } from 'src/app/shared/enums/state.enum';

@Component({
	selector: 'app-nav-routes',
	templateUrl: './nav-routes.component.html',
	styleUrls: ['./nav-routes.component.scss']
})
export class NavRoutesComponent {
	@Input() addable = false;

	@Output() addEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
	@Output() urlEvent = new EventEmitter();

	today = new Date();
	routeState = State;

	constructor(public router: Router, public route: ActivatedRoute) {}

	// ngOnInit(): void {}

	scrollTop() {
		window.scroll(0, 0);
	}

	submitCurrentTab(url) {
		this.urlEvent.emit(url);
	}
}
